module.exports = __webpack_public_path__ + "static/hero-e93368da89877081db1c4433c34629ec.jpg";